<template>
  <DefaultLayout>
    <template #buttons>
      <DepartmentCreateAction @created="reload" v-if="can('DEPARTMENT_MANAGE')" />
    </template>

    <DepartmentFilter :filters="filters">
      <h1 class="h5 mt-2">
        {{ i18n('Departments') }}
        <span class="small text-muted" v-if="!pagination?.total">({{ departments.length }})</span>
        <span class="small text-muted" v-else>({{ pagination?.total }})</span>
      </h1>
      <template #buttons>
        <ExportToExcelAction cssClass="btn btn-sm btn-outline-dark ms-1" />
      </template>
    </DepartmentFilter>

    <DepartmentList :pagination="pagination" :departments="departments" :loading="loading"
      :autoLazyLoad="!!pagination.nextPageURI" @deleted="reload" @updating="loading = true" @updated="reload"
      @next="nextPage" @goToPage="goToPage" />
  </DefaultLayout>
</template>

<script>
import paginatedViewMixin from "@/mixins/common/paginatedViewMixin.js";
import api from "@/api.js";
import { canAccessPage } from "@/routeAcl.js";
import DefaultLayout from "@/layouts/DefaultLayout.vue";
import ExportToExcelAction from "@/components/common/actions/ExportToExcelAction.vue";
import DepartmentCreateAction from "@/components/department/DepartmentCreateAction.vue";
import DepartmentFilter from "@/components/department/DepartmentFilter.vue";
import DepartmentList from "@/components/department/DepartmentList.vue";

export default {
  mixins: [paginatedViewMixin,],
  components: {
    DefaultLayout,
    ExportToExcelAction,
    DepartmentCreateAction,
    DepartmentFilter,
    DepartmentList,
  },
  data() {
    return {
      listPropertyName: 'departments',
      apiResource: `departments`,
      departments: [],
    }
  },
  mounted() {
    this.$root.setPageTitle(this.i18n('Departments'));
    api.auth().then((user) => {
      this.$root.loggedUser = user;

      if (!user.loggedIn) {
        return; // Layout non-anonymous will handler redirect
      }

      if (!canAccessPage(this.$route?.name, user, this.$root.features)) {
        this.$router.push({ name: 'Index', });
        return;
      }

      this.load();
    });
  },
  watch: {
    params: {
      handler() {
        this.pagination.loadPages = 1;
        this.reload();
      },
      deep: true,
    },
  },
  methods: {
    extendApiParams(params) {
      params.acl = 'department';
    },
  },
};
</script>